export function DtoDataResDataInfo() {
    return {
            idUsuario: '',
            identificacion: '',
            nombres: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correoElectronico: '',
            numeroCelular: '',
    }
}